import script from "./ProductConsultationInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductConsultationInfo.vue?vue&type=script&setup=true&lang=ts"

import "./ProductConsultationInfo.vue?vue&type=style&index=0&id=63f54ead&scoped=true&lang=css"

import exportComponent from "G:\\IT\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63f54ead"]])

export default __exports__